import { NgClass, NgTemplateOutlet } from "@angular/common";
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ViewChild,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { SpanComponent } from "../../../span/span.component";
import { GridBaseComponent } from "../grid-base/grid-base.component";

@Component({
    selector: "rask-grid-span",
    templateUrl: "./grid-span.component.html",
    styleUrls: ["./grid-span.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SpanComponent,
        NgbPopover,
        NgClass,
        NgTemplateOutlet
    ]
})

export class GridSpanComponent extends GridBaseComponent implements AfterViewInit {
    popoverDisabled = false;
    presentationValue: any;
    @ViewChild("templateResult") templateResult;
    usePlaceHolder: boolean;

    private readonly changeRef = inject(ChangeDetectorRef);

    ngAfterViewInit(): void {
        this.changeRef.detectChanges();
    }

    onInit(): void {
        this.popoverDisabled = typeof this.tooltipValue !== "string";
        this.usePlaceHolder = !ObjectUtils.hasValue(this.value);
        if(this.viewFormatter) {
            this.presentationValue = this.viewFormatter(ObjectUtils.hasValue(this.value) ? this.value : this.placeholder);
        } else {
            this.presentationValue = ObjectUtils.hasValue(this.value) ? this.value : this.placeholder;
        }
    }
}
